import { InjectionToken } from "@angular/core";

export const BASE_URI = new InjectionToken(`Base uri for all transaction calls`);
